/** @format */
import { Button, ButtonSize } from '@mpb-com/feather/components/atoms/button';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';

import { useTermsAndConditions } from '@toucan/hooks/use-terms-and-conditions';

import { useCheckout } from '@toucan/client/features/checkout';

import { StyledCompleteCheckoutControl } from './complete-checkout-control.styles';
import { CompleteCheckoutControlProps } from './types';

export const CompleteCheckoutControl: FunctionComponent<
    CompleteCheckoutControlProps
> = ({
    paymentError,
    onClick,
    disabled,
    'data-testid': dataTestId = 'checkout-payment',
}) => {
    const { t } = useTranslation();
    const { isSubmitting } = useCheckout();

    const { termsAndConditionsNode, disableSubmitButton } =
        useTermsAndConditions({ isSubmitting });

    return (
        <StyledCompleteCheckoutControl data-testid={dataTestId}>
            <div
                data-testid={`${dataTestId}__payment-error`}
                className="payment-error"
            >
                {paymentError}
            </div>
            <p data-testid={`${dataTestId}__terms-and-conditions`}>
                {termsAndConditionsNode}
            </p>
            <Button
                type="submit"
                className="submit-button"
                size={ButtonSize.LARGE}
                disabled={disabled ?? disableSubmitButton}
                data-testid={`${dataTestId}__submit`}
                isLoading={isSubmitting}
                onClick={onClick}
            >
                {t('Complete and pay')}
            </Button>
        </StyledCompleteCheckoutControl>
    );
};
